import React, {useState, useEffect} from "react";
import { useTable, useSortBy } from "react-table";
import { Link } from "react-router-dom";

import { API_URL } from "../../../constants";
import { ARRAY_EMPTY, GET_TOKEN, OBJECT_EMPTY } from "../../../helpers";
import { GET_INTEGRATION_DATA_STATUS, POST_GET_INTEGRATIONS } from "../../../constants";
import { EmptyWidget } from '../EmptyWidget';
import { LoadingSpinner } from "../partials/LoadingSpinner";
import { SmallSpinner } from "../partials/SmallSpinner";
import "./Integrations.css";

export const Integrations = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [dataStatus, setDataStatus] = useState({});
  const [data, setData] = useState([]);

  const columns = [
    {
      Header: "in_progress",
      accessor: "in_progress",
    },
    {
      Header: "Source",
      accessor: "integration_type",
    },
    {
      Header: "Account name",
      accessor: "id",
    },
    {
      Header: "Integration date & time",
      accessor: "created_at",
    },
    {
      Header: "Historical data (From)",
      accessor: "historical_date",
    },
    {
      Header: "Next data import",
      accessor: "next_import",
    },
    {
      Header: "",
      accessor: "settings",
    },
  ];

  let fetchIntegrationStatus = () => {
    fetch(API_URL + GET_INTEGRATION_DATA_STATUS, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setDataStatus(response)
      })
  }

  let fetchTableData = () => {
    fetch(API_URL + POST_GET_INTEGRATIONS, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setData(response)
      })
      .finally(() => {
        setDataLoaded(true)
      })
  }

  useEffect(() => {
    fetchTableData();
  }, [])

  // Status box of Integrations
  useEffect(() => {
    fetchIntegrationStatus();
  }, [])

  // Status box of Integrations Recurring Fetch
  useEffect(() => {
    let fetchReccuringInfo = setInterval(() => fetchIntegrationStatus(), 10000);

    return () => clearInterval(fetchReccuringInfo)
  })

  // Table data Recurring Fetch
  useEffect(() => {
    let fetchData = setInterval(() => fetchTableData(), 10000);

    return () => clearInterval(fetchData)
  })

  const Table = ({ columns, data }) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
    } = useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

    return (
      <>
        <table {...getTableProps()} className="default-table">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  column.Header !== "in_progress" && (
                    <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                    {column.render("Header")}

                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                  )
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row);
              let inProgress;

              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    if (cell.column.id === "in_progress") {
                      return inProgress = cell.value;
                    } else if (cell.column.id === "id") {
                      return (
                        <td
                          {...cell.getCellProps()}
                          className="Integrations__cell"
                        >

                          {inProgress && <div className="in_progress">In progress</div>}
                          {cell.render("Cell")}

                        </td>
                      )
                    }
                    
                    else {
                      return (
                        <td
                          {...cell.getCellProps()}
                          className={
                            "Integrations__cell " + cell.column.id === "settings"
                              ? "Integrations__setting"
                              : ""
                          }
                        >
                          {cell.column.id === "settings" ? (
                            <div className="Integrations__setting-button icon"></div>
                          ) : cell.column.id === "integration_type" ? (
                            <div
                              className={
                                "Integrations__source_img logo " +
                                `img_${cell.value}`
                              }
                            ></div>
                          ) : (
                            cell.render("Cell")
                          )}
                        </td>
                      );
                    }
                                      
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <br />
      </>
    );
  };

  return (
    <>
      <div className="Dashboard__content__top-row">
        <h2> My Integrations</h2>

        <ul className="Dashboard__content__top-row__selectors">
          {/* green plus button */}
          <Link to="/user/provider" exact="true" className="button__add-new" />
        </ul>
      </div>

      <div className="Integrations">
        {OBJECT_EMPTY(dataStatus) === false && (
            dataStatus['status'] !== undefined && dataStatus['status'].map((item, index) => {
              return (
                <div className="Integrations-status" key={item.order + index}>
                  <div className="left">
                    <div className="Integrations-status__provider"><b>{item.type}</b></div>
                    {item.name && <div className="Integrations-status__id"><b>{item.name}</b></div>}
                    <div className="Integrations-status__message">
                        {
                          item.status === 'TRANSACTIONS UPDATING'
                            ?'integration in progress'
                            : item.status
                        }
                    </div>
                  </div>

                  <div className="right">
                    <div className="Integrations-status__spinner"><b><SmallSpinner/></b></div>
                    <div className="Integrations-status__status">Processing</div>
                    {item.order && <div className="Integrations-status__status"><b> {item.order} </b></div>}
                    {(item.count && item.iterator) && (
                      <div className="Integrations-status__out-of"><b>({item.iterator} of {item.count})</b></div>
                    )}
                  </div>
                </div>
              )
            })
        )}

        {/* {data.length > 0 
        // && dataStatus.data_status === 'not_empty' 
          ? <Table columns={columns} data={data} />
          : !dataLoaded 
            ? <LoadingSpinner/>
            : dataStatus.data_status === 'empty'
            


            ?&& dataStatus.data_status === 'empty'
            ? (
                <EmptyWidget
                  text="No data imported yet"
                  ctaText="Let's start with your first integration?"
                  buttonText='Go to integrations'
                  buttinLink='/user/provider'
                />
              )
            : <LoadingSpinner/>
        } */}


        {
          !dataLoaded
            ? <LoadingSpinner/>
            : data.length > 0
              ? <Table columns={columns} data={data} />
              : <EmptyWidget
                  text="No data imported yet"
                  ctaText="Let's start with your first integration?"
                  buttonText='Go to integrations'
                  buttinLink='/user/provider'
                />
        }


      </div>
    </>
  );
};
